import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import RingilSidebar from '@components/ringil3/Sidebar/RingilSidebar';
import COInlineMessage from '@components/ringil3/COInlineMessage/COInlineMessage.tsx';
import CoInlineMessageInfo from '@components/ringil3/COInlineMessage/icons/CoInlineMessageInfo';
import CoInlineMessageWarning from '@components/ringil3/COInlineMessage/icons/CoInlineMessageWarning';

interface ComponentProps {
  visible: boolean;
  /** The tab has unsaved changes: colleagues get its saved version, so the user is told. */
  modified: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/** "Sdílet pohled" (Figma 21944:65259): a single confirm — the tab appears for every colleague, no picker. */
const ShareViewSidebar: React.FC<ComponentProps> = ({ visible, modified, onConfirm, onClose }) => {
  const { tr } = useTranslationLgs();
  return (
    <RingilSidebar
      visible={visible}
      heading={tr('TableViews.share', 'Share with colleagues')}
      onContinue={() => {
        onConfirm();
        onClose();
      }}
      onBack={onClose}
      showSaveButton
      showBackButton
    >
      <div className="flex flex-col gap-2" data-testid="table-view-share">
        <COInlineMessage variant="info" icon={<CoInlineMessageInfo />}>
          {tr('TableViews.shareInfo', 'The view will appear as a new tab for all your colleagues.')}
        </COInlineMessage>
        {modified && (
          <COInlineMessage variant="warning" icon={<CoInlineMessageWarning />}>
            {tr('TableViews.shareUnsaved', 'Your unsaved changes are not shared. Save the view first if colleagues should get them.')}
          </COInlineMessage>
        )}
      </div>
    </RingilSidebar>
  );
};

export default ShareViewSidebar;
